import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class Notification extends Base {
  /**
   * @description List location API function
   * @returns {Promise<Response>}
   */
  list(app, page = "") {
    const url = this._getFullURL(`/notification?app=${app}&page=${page}`);
    return this._secureFetch(url);
  }
  listNotifThreshold(query) {
    const queryString = new URLSearchParams(query).toString();
    const url = this._getFullURL(`/notification/threshold?${queryString}`);
    return this._secureFetch(url);
  }

  listNew(app) {
    const url = this._getFullURL(`/notification/new?app=${app}`);
    return this._secureFetch(url);
  }
}
